import { useCallback } from 'react';

import { useAppSelector } from '../store/store';

import { useUserRole } from './useUserRole';

export function useTravelerSelfCheck() {
  const clientTeamMemberId = useAppSelector(
    (state) => state.user.profile?.clientTeamMemberId,
  );
  const { isOnlyTraveler } = useUserRole();
  const selfBookingEnabled = useAppSelector(
    (state) =>
      state.enums.featureFlags?.flags.hotelSavedCards === true &&
      state.user.profile?.client?.clientPortalTravelerSelfBookingEnabled ===
        true,
  );

  const isOwnRosterEntry = useCallback(
    (guestId: string | number | undefined | null): boolean => {
      if (!clientTeamMemberId || !guestId) return false;
      return String(guestId) === String(clientTeamMemberId);
    },
    [clientTeamMemberId],
  );

  return {
    clientTeamMemberId,
    isOnlyTraveler,
    isOwnRosterEntry,
    hasLinkedProfile: Boolean(clientTeamMemberId),
    selfBookingEnabled,
    canSelfBook:
      !isOnlyTraveler || (selfBookingEnabled && Boolean(clientTeamMemberId)),
  };
}
